import React from "react";

export const diasYHorasContent = (
  <div>
    <p className="content justified">
      Su primera obra de teatro, titulada “Vida plena”, la escribió siendo estudiante, en 1927, en compañía de Gerardo
      Valencia.
    </p>
    <p className="content justified">
      Su primer cuento publicado, “Los días y las horas”, apareció en la revista <em>8 de junio</em>, bajo el seudónimo
      Asnaldo Díaz D, en 1929, escrito a sus 19 años. Siete años después empezó a escribir en la revista infantil{" "}
      <em>Rin Rin.</em>
    </p>
    <p className="content justified">
      En 1938, con ilustraciones del célebre Sergio Trujillo Magnenat, publicó su primer libro de cuentos titulado{" "}
      <em>El país de Lilac.</em>
    </p>
    <p className="content justified">
      Otros de los nombres bajo los cuales firmaba sus cuentos fueron OSWALDIAZ y ODD, además, por supuesto, de Oswaldo
      Díaz Díaz.
    </p>
  </div>
);
